import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsRoutes } from '../forms/forms-routing.module';
import { SelectedClientComponent } from './components/selected-client/selected-client.component';
import { LoginModule } from '../login/login.module';
import { Form1Component } from './components/form1/form1.component';
import { Form2Component } from './components/form2/form2.component';
import { Form3Component } from './components/form3/form3.component';
import { Form4Component } from './components/form4/form4.component';
import { Form5Component } from './components/form5/form5.component';
import { Form6Component } from './components/form6/form6.component';
import { LayoutCustomModule } from '../../layouts/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
// import { CustomSpinnerComponent } from './shared/components/custom-spinner/custom-spinner.component';
import { CustomSpinnerComponent } from '../../shared/components/custom-spinner/custom-spinner.component';
//import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { DecimalPipe, CurrencyPipe, registerLocaleData } from '@angular/common';
import {CurrencyMaskInputMode, NgxCurrencyModule } from "ngx-currency";
import localeFr from '@angular/common/locales/es';
import { MatDatepicker } from "@angular/material/datepicker";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {​​ MatInputModule }​​ from '@angular/material/input';
// import { FormatCurrencyPipe } from './formcurrencypipe/formatcurrency.pipe';
registerLocaleData(localeFr, 'es');


export const customCurrencyMaskConfig = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "",
    suffix: "",
    thousands: ".",
    nullable: true,
    min: 0,
    max: 999999999,
    inputMode: CurrencyMaskInputMode.NATURAL
};

@NgModule({
    declarations: [SelectedClientComponent, Form1Component, Form2Component, Form3Component, Form4Component, Form5Component, Form6Component],
    providers: [
        
        DecimalPipe,
        CurrencyPipe,
        {​​provide: MAT_DATE_LOCALE, useValue: 'en-GB'}​​
        
    ],
    imports: [
        CommonModule,
        MatNativeDateModule, MatMomentDateModule,
        MatInputModule,
        NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
        TranslateModule,
        SharedModule,
        LoginModule,
        FormsModule,
        LayoutCustomModule,
        ReactiveFormsModule,
        ReactiveFormsModule,
        OverlayModule,
        HttpClientModule,
        MatDatepickerModule,
        NgHttpLoaderModule.forRoot(),
        RouterModule.forChild(FormsRoutes)
    ],
    entryComponents: [CustomSpinnerComponent],
    exports: [SelectedClientComponent, Form1Component, Form2Component, Form3Component, Form4Component, Form5Component, Form6Component]
})
export class FormsDeclarationModule { }
